module.exports = __webpack_public_path__ + "static/media/kappa-slappa-thigh-low-resolution-logo-color-on-transparent-background.4e32aa20.png";